export default {
  activeClass: "active",
  windowEl: window,
  documentEl: document,
  htmlEl: document.documentElement,
  bodyEl: document.body,
  header: document.querySelector('header'),
  footer: document.querySelector('footer'),
  burger: document.querySelectorAll('.burger'),
  mobileMenu: document.querySelector('.header-menu'),
  overlay: document.querySelector('[data-overlay]'),
  
  partnersSlider: document.querySelector('.partners-section__slider'),
  promoSlider: document.querySelector('.promo__slider'),






}





